import './App.css';
import Home from './Components/Home';
import './Fonts/fonts.module.css';

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
